import { useAuth } from "@/contexts/AuthContext";
import { LogOut, ShieldAlert } from "lucide-react";

export function ImpersonationBanner() {
  const { impersonation, stopImpersonate } = useAuth();
  if (!impersonation) return null;
  return (
    <div
      data-testid="impersonation-banner"
      className="bg-amber-500 text-amber-950 dark:bg-amber-600 dark:text-amber-50 px-4 py-2 flex items-center justify-between text-sm border-b border-amber-700"
    >
      <div className="flex items-center gap-2">
        <ShieldAlert className="w-4 h-4" />
        <span className="font-semibold uppercase tracking-wider text-xs">Impersonation Mode</span>
        <span className="opacity-80">·</span>
        <span>
          Viewing as <span className="font-semibold">{impersonation.target_name}</span>
        </span>
      </div>
      <button
        onClick={stopImpersonate}
        data-testid="stop-impersonate-btn"
        className="flex items-center gap-1.5 px-3 py-1 rounded-sm bg-amber-950/20 hover:bg-amber-950/30 text-xs font-medium"
      >
        <LogOut className="w-3.5 h-3.5" /> Return to Master Admin
      </button>
    </div>
  );
}
